export default "__VITE_ASSET__CPeZLOP3__"